import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './MainPage/HomePage';
import OnboardPage from './MainPage/OnboardPage';
import DashBoard from './MainPage/DashBoard';
import MyComponent from './TestingGrounds/MyComponent';
import SignInTerminal from './MainPage/SignInTerminal';
import { AuthProvider } from './AuthContext';
import TerminalPage from './MainPage/TerminalPage';

import AdminPage from './AdminPages/AdminDashboard';
import SignInPage from './MainPage/SignInPage';
import CreatingAd from './TestingGrounds/CreatingAd';
import PullingInfo from './TestingGrounds/PullingInfo';
import ProtectedRoute from './ProtectedRoute';
import LanguageSelector from './LenguageSelector';
import ShowwList from './TestingGrounds/ShowwList';
import CompetitionReserve from './MainPage/CompetitionReserve';
import CompetitionRev from './CompetitionRev';
import CompeteTotalForm from './MainPage/CompeteTotalForm';
import TodayMusicians from './MainPage/TodayMusicians';



function App() {
  return (
    <AuthProvider>
            <LanguageSelector /> {/* Language Selector Component */}
    <Router>
      <div className="">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/Competition" element={<CompeteTotalForm />} />
          <Route path="/Onboard" element={<OnboardPage />} />
          <Route path="/SignInTerminal" element={<SignInPage />} />
          <Route path="/TerminalPage" element={<TerminalPage />} />
          <Route path="/Admin" element={<AdminPage />} />
          <Route path="/Compi" element={<CompetitionRev />} />

          <Route
  path="/DashBoard"
  element={
    <ProtectedRoute>
      <DashBoard />
    </ProtectedRoute>
  }
/>

        
        </Routes>
      </div>
    </Router>
    </AuthProvider>
  );
}

export default App;
